import React from "react";
import { Box, Button, Typography } from '@mui/material';

const PatrolStatus = ({ impersonatedUser, patrol }) => {

  return (
    <>
      
      <Box
        display='flex'
        flexWrap="wrap"
        flexDirection='column'
        gap={2}
        sx={{
          mat: 40,
          bgcolor: 'background.white',
        }}
        height='72px'
      >
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          minWidth: 275,
          height: '100%'
        }}>
          <Box sx={{
            pl: '50px',
            pt: '5px',
            backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxNyAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNSAxMi41SDEyLjVDMTQuNDMzIDEyLjUgMTYgMTQuMDY3IDE2IDE2VjE5QzE2IDE5LjI3NjEgMTUuNzc2MSAxOS41IDE1LjUgMTkuNUgxLjVDMS4yMjM4NiAxOS41IDEgMTkuMjc2MSAxIDE5VjE2QzEgMTQuMDY3IDIuNTY3IDEyLjUgNC41IDEyLjVaTTguNSAwLjVDOS42OTM0NyAwLjUgMTAuODM3NyAwLjk3NDQ0NiAxMS42ODE2IDEuODE4MzZDMTIuNTI1NiAyLjY2MjI3IDEzIDMuODA2NTMgMTMgNUMxMyA3LjQ4NTI4IDEwLjk4NTMgOS41IDguNSA5LjVDNi4wMTQ3MiA5LjUgNCA3LjQ4NTI4IDQgNUM0IDIuNTE0NzIgNi4wMTQ3MiAwLjUgOC41IDAuNVoiIGZpbGw9IiMwMDA4MUMiIHN0cm9rZT0iIzAwMDgxQyIvPgo8L3N2Zz4=')",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '18% 50%'
          }}>
            <Typography sx={{ 
              flexGrow: 1, 
              fontSize: '16px', 
              color: 'text.secondary',
              fontFamily: 'New Transport',
              fontWeight: 400
            }}>
              {impersonatedUser && <span style={{ color: 'red', paddingLeft: '14px' }}>IMPERSONATED/</span>}
              CS {patrol?.callsign}
            </Typography>
          </Box>
          <Box sx={{
            pr: '20px'
          }}>
            <Button
              onClick={() => {}}
              type="submit"
              variant="status"
            >
              {patrol?.status.code}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default PatrolStatus;
